import styled from 'styled-components';
import { rem } from '@innovyze/stylovyze';

export const StyledContainer = styled.div`
	width: 100%;
	height: ${rem(500)};
	position: relative;
	display: table;
`;
